import { scaleBand, type ScaleBand, scaleLinear } from 'd3-scale';
import { createContext } from 'react';

import type { CategoricalValueScales } from '../types/categorical-bar-chart.js';

export interface CategoricalChartScales {
  categoryScale: ScaleBand<string>;
  valueScale: CategoricalValueScales;
  dimensionScale: ScaleBand<string>;
}
export const CategoricalBarChartScalesContext =
  createContext<CategoricalChartScales>({
    categoryScale: scaleBand(),
    valueScale: scaleLinear(),
    dimensionScale: scaleBand(),
  });
